import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-5',
  templateUrl: './5.component.html',
  styleUrls: ['./5.component.scss'],
})
export class VbList5Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
